module.exports = __webpack_public_path__ + "img/10865_L.95f2724a.png";